import { Flex } from 'antd'
import { flexSchema } from '../schemas'
import { renderSchemaArray } from '../utils'
import { withParsedData } from './base'

export const FlexRenderer = withParsedData(flexSchema)<{ source?: object }>(({ parsedData, source }) => {
  const { body, style, ...rest } = parsedData
  const children = renderSchemaArray(body, source)

  return (
    <Flex {...rest} style={style}>
      {children}
    </Flex>
  )
})
